import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./hero_area.scss";
import shapeImg from "../../images/shape/shape_1.png";
import SliderItem from "../../SingleFeatures/slider_item";
import slider_02_img from "../../images/banner_02.png";
import slider_03_img from "../../images/banner_03.png";
import slider_04_img from "../../images/banner_04.png";

export default function Index() {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    }
    return (
        <section className="deneb_banner carousel-style banner_v1">
            <div className="shape_v1">
                <img src={shapeImg} className="shape_1" alt="shape"/>
            </div>
            <div className="container">
                <div className="hero_slider">
                    <Slider {...settings}>
                        <SliderItem
                            title="Application Development"
                            sub_title=""
                            heading="Functional, Usability & Performance"
                            description="We help to Develop powerful, highly user-friendly mobile apps that solve your business difficulties, attract users, and reinforce your brand. We build native, hybrid, and cross-platform apps that run on all major operating systems such as iOS and Android. "
                            url="/contact"
                            img={slider_04_img}
                        />
                        <SliderItem
                            title="Website Development"
                            sub_title=""
                            heading="Functional, Usability & Performance"
                            description="We have the expertise and experience to help businesses build dynamic, database-driven, and high-quality enterprise-level websites. Over the years, we have developed several web applications, eCommerce systems, content management systems, as well as back-end systems for data handling. We offer cost-effective solutions for our clients through an affordable and conventional delivery platform."
                            url="/contact"
                            img={slider_02_img}
                        />
                        <SliderItem
                            title="Custom Software Development"
                            sub_title=""
                            heading="Functional, Usability & Performance"
                            description="We transform businesses of most major sectors with powerful and adaptable digital solutions that satisfy the needs of today."
                            url="/contact"
                            img={slider_03_img}
                        />
                    </Slider>
                </div>
            </div>
        </section>

    )
}
